import { KIND_META } from './kinds'

// {lớp} để nguyên: server thay theo từng lớp (nameForClass)
export const NAME_TOKENS = ['{ngày giao}', '{lớp}', '{loại bài}', '{số thứ tự}']

const pad = (n) => String(n).padStart(2, '0')

export function formatDayMonth(value) {
  if (!value) return ''
  const d = new Date(value)
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}`
}

export function formatDateTime(value) {
  if (!value) return '—'
  const d = new Date(value)
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} · ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function kindLabel(item) {
  return (KIND_META[item.kind] || KIND_META.exercise).label
}

export function resolveTokens(text, { startAt, item, position }) {
  return String(text || '')
    .replace(/\{ngày giao\}/g, formatDayMonth(startAt))
    .replace(/\{loại bài\}/g, item ? kindLabel(item) : '')
    .replace(/\{số thứ tự\}/g, position ? String(position) : '')
}

// Tên từng bài = tiền tố + tên gốc, trừ bài đã sửa tay; bài trùng tên với bài trước tự thêm "(loại bài)"
export function buildItemNames(items, { prefix, overrides, startAt }) {
  const rows = items.map((item, i) => {
    const edited = Object.prototype.hasOwnProperty.call(overrides, item._id)
    const raw = edited ? overrides[item._id] : `${prefix || ''}${item.title}`
    return { item, edited, name: resolveTokens(raw, { startAt, item, position: i + 1 }).trim(), kindAdded: false }
  })

  const seen = new Set()
  rows.forEach((row) => {
    if (row.name && seen.has(row.name) && !row.edited) {
      row.name = `${row.name} (${kindLabel(row.item)})`
      row.kindAdded = true
    }
    seen.add(row.name)
  })
  return rows
}
